import { format } from "date-fns";

import { SQL_SERVER_MAX_DATE, SQL_SERVER_MIN_DATE } from "@/helpers/date";

type QueryParamRawValue = string | undefined;

export const parseQueryParamToString = (value: QueryParamRawValue): string | undefined => {
  if (value === undefined) {
    return undefined;
  }

  if (Array.isArray(value)) {
    return value[0];
  }

  return value;
};

export const parseQueryParamToNumber = (value: QueryParamRawValue): number | undefined => {
  const str = parseQueryParamToString(value);
  if (str === undefined) {
    return undefined;
  }

  const num = Number(str);

  return isNaN(num) ? undefined : num;
};

export const parseQueryParamToDateString = (value: QueryParamRawValue): string | undefined => {
  const date = parseQueryParamToDate(value);
  if (date === undefined) {
    return undefined;
  }

  return format(date, "yyyy-MM-dd");
};

export const parseQueryParamToDate = (value: QueryParamRawValue): Date | undefined => {
  const str = parseQueryParamToString(value);
  if (str === undefined) {
    return undefined;
  }

  const timestamp = Date.parse(str);
  if (isNaN(timestamp)) {
    return undefined;
  }

  const date = new Date(timestamp);

  return date >= SQL_SERVER_MIN_DATE && date <= SQL_SERVER_MAX_DATE ? date : undefined;
};

export const parseQueryParamToList = <T = string>(
  value: QueryParamRawValue,
  validator?: (value: string) => boolean,
): T[] | undefined => {
  if (value === undefined) {
    return undefined;
  }

  const list = value
    .split(",")
    .map((v) => v.trim())
    .filter((v) => Boolean(v) && (!validator || validator(v))) as T[];

  return list.length > 0 ? list : undefined;
};

export const parseQueryParamToBoolean = (value: QueryParamRawValue): boolean | undefined => {
  const str = parseQueryParamToString(value);

  if (str === "true") {
    return true;
  }

  if (str === "false") {
    return false;
  }

  return undefined;
};
